import { callApi, callApiWithData } from './call-api';
import MealPlan, { mapMealPlanFromApi, MealPlanStatus } from '../models/meal-plan';

export const getMealPlans = async (status?: MealPlanStatus): Promise<MealPlan[]> => {
  const query = status ? `?status=${status}` : '';
  const response = await callApi(`/chef-meal-plans${query}`);
  return (response.mealPlans ?? []).map(mapMealPlanFromApi);
};

export const createMealPlan = async (name: string, dueDate?: string): Promise<MealPlan> => {
  const data: { name: string; dueDate?: string } = { name };
  if (dueDate) {
    data.dueDate = dueDate;
  }
  const response = await callApiWithData('/meal-plan', data, 'POST');
  return mapMealPlanFromApi(response.mealPlan);
};

export const updateMealPlan = async (id: string, name: string, dueDate?: string | null): Promise<MealPlan> => {
  const data: { name: string; dueDate?: string | null } = { name };
  if (dueDate !== undefined) {
    data.dueDate = dueDate;
  }
  const response = await callApiWithData(`/meal-plan/${id}`, data, 'PUT');
  return mapMealPlanFromApi(response.mealPlan);
};

export const deleteMealPlan = async (id: string): Promise<void> => {
  await callApi(`/meal-plan/${id}`, 'DELETE');
};

export const addMealToPlan = async (mealPlanId: string, mealId: string): Promise<void> => {
  await callApiWithData('/meal-plan-item', { mealPlanId, mealId }, 'POST');
};

export const removeMealFromPlan = async (itemId: string): Promise<void> => {
  await callApi(`/meal-plan-item/${itemId}`, 'DELETE');
};

export const completeMealPlan = async (planId: string, cookedMealIds: string[], cookedDate: string): Promise<void> => {
  await callApiWithData(`/meal-plan/${planId}/complete`, { cookedMealIds, cookedDate }, 'POST');
};
